import { useEffect, useState } from "react";

import { HiChevronLeft } from "components/atoms/Icon/hi/HiChevronLeft";

function Pagination({ pages = 6, setCurrentPage }) {
  // Set number of pages
  const numberOfPages = [];

  for (let i = 1; i <= pages; i++) {
    numberOfPages.push(i);
  }

  // Current active button number
  const [currentButton, setCurrentButton] = useState(1);

  // Array of buttons what we see on the page
  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  useEffect(() => {
    let tempNumberOfPages = [...arrOfCurrButtons];

    const dotsInitial = "...";
    const dotsLeft = "... ";
    const dotsRight = " ...";

    if (numberOfPages.length < 10) {
      tempNumberOfPages = numberOfPages;
    } else if (currentButton >= 1 && currentButton <= 3) {
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentButton === 4) {
      const sliced = numberOfPages.slice(0, 5);

      tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    } else if (currentButton > 4 && currentButton < numberOfPages.length - 2) {
      // From 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(currentButton - 2, currentButton); // Sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(currentButton, currentButton + 1); // Sliced1 (5, 5+1) -> [6]

      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentButton > numberOfPages.length - 3) {
      // > 7
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // Slice(10-4)

      tempNumberOfPages = [1, dotsLeft, ...sliced];
    } else if (currentButton === dotsInitial) {
      // Array [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // ArrOfCurrButtons[3] = 4 + 1 = 5
      // Or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      setCurrentButton(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentButton === dotsRight) {
      setCurrentButton(arrOfCurrButtons[3] + 2);
    } else if (currentButton === dotsLeft) {
      setCurrentButton(arrOfCurrButtons[3] - 2);
    }

    setArrOfCurrButtons(tempNumberOfPages);
    setCurrentPage(currentButton);
  }, [currentButton, pages]);

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={() =>
          setCurrentButton((prev) => (prev <= 1 ? prev : prev - 1))
        }
        disabled={currentButton === 1}
        className={"mr-4 disabled:grayscale"}
      >
        <HiChevronLeft
          size={24}
          color="#007eff"
          className="rounded-md bg-bbc-brand-100 p-0.5"
        />
      </button>

      <ul className="flex list-none flex-wrap justify-center rounded pl-0">
        <li>
          {arrOfCurrButtons.map((number, index) => (
            <button
              key={index}
              onClick={() => {
                setCurrentButton(number);
              }}
              className={`px-2 ${
                currentButton === number
                  ? "font-medium text-bbc-brand-500 underline"
                  : " text-bbc-neutral-700"
              }`}
            >
              {number}
            </button>
          ))}
        </li>
      </ul>

      <button
        onClick={() =>
          setCurrentButton((prev) =>
            prev >= numberOfPages.length ? prev : prev + 1
          )
        }
        disabled={currentButton === numberOfPages.length}
        className={"ml-4 disabled:grayscale"}
      >
        <HiChevronLeft
          size={24}
          color="#007eff"
          className="rotate-180 rounded-md bg-bbc-brand-100 p-0.5"
        />
      </button>
    </div>
  );
}

export default Pagination;
